/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_No_Text_FoundInputs */

const en_ocr_no_text_found = /** @type {(inputs: Ocr_No_Text_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No text was detected in the video.`)
};

const fr_ocr_no_text_found = /** @type {(inputs: Ocr_No_Text_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun texte n'a été détecté dans la vidéo.`)
};

const de_ocr_no_text_found = /** @type {(inputs: Ocr_No_Text_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Video wurde kein Text erkannt.`)
};

const it_ocr_no_text_found = /** @type {(inputs: Ocr_No_Text_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nel video non è stato rilevato alcun testo.`)
};

const ru_ocr_no_text_found = /** @type {(inputs: Ocr_No_Text_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В видеоролике текст не обнаружен.`)
};

const es_ocr_no_text_found = /** @type {(inputs: Ocr_No_Text_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se detectó texto en el vídeo.`)
};

const zh_cn2_ocr_no_text_found = /** @type {(inputs: Ocr_No_Text_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频中未检测到任何文字。`)
};

const ja_ocr_no_text_found = /** @type {(inputs: Ocr_No_Text_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画内にテキストは検出されませんでした。`)
};

const hi_ocr_no_text_found = /** @type {(inputs: Ocr_No_Text_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो में कोई टेक्स्ट नहीं मिला।`)
};

const pt_pt2_ocr_no_text_found = /** @type {(inputs: Ocr_No_Text_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum texto foi detectado no vídeo.`)
};

/**
* | output |
* | --- |
* | "No text was detected in the video." |
*
* @param {Ocr_No_Text_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_no_text_found = /** @type {((inputs?: Ocr_No_Text_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_No_Text_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_no_text_found(inputs)
	if (locale === "de") return de_ocr_no_text_found(inputs)
	if (locale === "it") return it_ocr_no_text_found(inputs)
	if (locale === "ru") return ru_ocr_no_text_found(inputs)
	if (locale === "es") return es_ocr_no_text_found(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_no_text_found(inputs)
	if (locale === "ja") return ja_ocr_no_text_found(inputs)
	if (locale === "hi") return hi_ocr_no_text_found(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_no_text_found(inputs)
	return en_ocr_no_text_found(inputs)
});